<template>
    <div>

        <!--导航栏 start-->
        <van-nav-bar
                title="添加会员卡"
                left-text="返回"
                @click-left="onClickLeft"
                left-arrow
                fixed
        />
        <!--导航栏 end-->
        <!--内容部分 start-->
        <van-form ref="forms" style="margin-top: 1.5rem">
            <van-field
                    v-model="name"
                    label="会员卡名称"
                    required
                    name="会员卡名称"
                    clearable
                    placeholder="请输入会员卡名称"
                    :rules="[{ required: true, message: '会员卡名称不能为空' }]"
            />
            <van-field name="单店模式" label="单店模式" required :rules="[{ required: true, message: '单店模式必须选择' }]">
                <template #input>
                    <van-radio-group v-model="single_store" direction="horizontal">
                        <van-radio :name="1">是</van-radio>
                        <van-radio :name="0">否</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
			<van-cell v-if="this.single_store=='1'" :value="select_stores.name" is-link title="选择门店" @click="show = true" 
			required :rules="[{ required: true, message: '门店必须选择' }]"/>
			<van-action-sheet
			  title="选择门店"
			  v-model="show"
			  :actions="storeList"
			  cancel-text="取消"
			  close-on-click-action
			  @select="selectList"
			  @cancel="onCancel"
			/>
			<van-field-checkbox
				v-if="this.single_store=='0'"
				label="选择门店"
				placeholder="请选择"
				v-model="store_ids"
				:columns="storeList"
				label-width="100"
				:option="{label:'store_name',value:'store_id'}"
				@confirm="confirm"
				required
				:rules="[{ required: true, message: '门店必须选择' }]"
			  />
			
			<van-row>
			  <van-col span="10">
				  <van-field
                    v-model="discount.recharge"
					label-width="1rem"
                    label="充值"
                    name="充值"
					/>
			  </van-col>
			  <van-col span="10">
				  <van-field
			        v-model="discount.discount"
					label-width="1rem"
			        label="优惠"
			        name="优惠"
					/>
			  </van-col>
			  <van-col span="4">
				  <van-button style="vertical-align: top;height: 1.14rem;" type="info" @click="addDiscount">添加</van-button>
			  </van-col>
			</van-row>
			
			<div style="padding: 14px;clear: both;font-size: 16px;background-color: #fff;">
			<div v-for="(data,index) in data_list" :key="index" prop="discount">
			  <div>
			    充值<span style="display: inline-block;width: 2.8rem;color: red;text-align: center;">{{data.recharge}}</span>
			    优惠<span style="display: inline-block;width: 2.8rem;color: red;text-align: center;">{{data.discount}}</span>
			    <span style="color: red;" @click="remove(index)">删除</span>
			  </div>
			
			</div>
			</div>
			
            
			

            <van-field name="uploader" label="会员卡logo" required :rules="[{ required: true, message: '会员卡logo必须选择' }]">
                <template #input>
                    <van-uploader :after-read="afterRead" v-model="logoList"   multiple :max-count="1"  />
                </template>
            </van-field>

            <van-field name="uploader" label="背景图">
                <template #input>
                    <van-uploader :after-read="afterReads" v-model="bgList"  multiple :max-count="1"  />
                </template>
            </van-field>
			
			<van-field
			        v-model="full_money"
			        label="消费满多少钱"
			        name="消费满多少钱"
			        clearable
			        placeholder="请输入消费满多少钱"
			/>
			<van-field
			        v-model="give_integral"
			        label="赠送积分"
			        name="赠送积分"
			        clearable
			        placeholder="请输入赠送积分"
			/>

        </van-form>
        <div style="margin: 16px;">
            <van-button @click="onSubmit" round block type="info" native-type="submit">
                确定
            </van-button>
        </div>
		
        <!--内容部分 end-->


    </div>
</template>

<script>
    // import VueCookie from 'vue-cookies'
    import {Notify, Toast} from 'vant';
	import VanFieldCheckbox from '@/components/VanFieldCheckbox'
    export default {
        name: "member_card_add", //会员卡添加
		components: {
		  VanFieldCheckbox
		},
        data() {
            return {
				
				selectStore:{},
				select_stores:'',
				show:false,
				store_ids: [],
				storeList:[],
		
				index:'',
				data:{},
				data_list:[],
                logoList: [],
                bgList: [],
                name: '',
				single_store:1,
				discount:{
					recharge:'',
					discount:''
					
				},
				full_money:'',
				give_integral:'',
            };
        },
        // 组件内路由--进入组件时
        beforeRouteEnter(to, from, next) {
            window.document.body.style.backgroundColor = '#f5f5f5';
            next();
        },
        // 组件内路由--离开组件时
        beforeRouteLeave(to, from, next) {
            window.document.body.style.backgroundColor = '';
            next();
        },
		created(){
			this.listStore()
		},
        methods: {
			selectList(action, index){
				this.select_stores=action;
				this.show=false;
			},
			onCancel() {
			      Toast('取消');
				  this.store_ids=[];
			    },
			listStore() {
			    this.$http.post('/wechat/api.card/listStore').then(response => {
			        if (response && response.body.code== 200) {
			            this.storeList=response.body.rows
						response.body.rows.map(item=>{
							item.name=item.store_name;
						})
			        }
			    })
			},
			confirm (data1, data2) { 
			      this.value3 = data2
			    },
			remove(index) {
			   this.data_list.splice(index, 1);
			},
			addDiscount() {
			  let isExist = false;
			   for(let i in this.data_list) {
			     if(this.data_list[i].recharge == this.discount.recharge && this.data_list[i].discount == this.discount.discount) {
			       isExist = true;
			     }
			  }
			  console.log(isExist);
			  if (this.discount.recharge == ""
			  ||this.discount.discount ==""
			  ||this.discount.recharge == undefined
			  ||this.discount.discount ==undefined
			  || isExist
			  ) {
			    return false;
			  }else{
			    this.data_list.push({
			      recharge:this.discount.recharge,
			      discount:this.discount.discount,
			    });
			    this.discount.recharge='';
			    this.discount.discount='';
			  }
			
			},

            afterRead(file) {
                this.$http.post('/wechat/api.merchant/wechatUploadMerchantImg', {
                        localData:file.content,
                        openid: window.localStorage.getItem("openid")

                }).then(response => {
                    if (response && response.data.code== 200) {
                        this.picture=response.data.local_img
                    }
                })
            },
            afterReads(file) {
                this.$http.post('/wechat/api.merchant/wechatUploadMerchantImg', {
                    localData:file.content,
                    openid: window.localStorage.getItem("openid")

                }).then(response => {
                    if (response && response.data.code== 200) {
                        this.background=response.data.local_img
                    }
                })
            },


            // 左侧返回
            onClickLeft() {
                this.$router.push("/member_card");
                // window.history.go(-1)
            },
            // 提交
            onSubmit() {
				// if(this.coupon_divide==''&&this.coupon_divide==null){
				//   this.coupon_divide=0;
				// }
                this.$refs.forms.validate().then(() => {
                    var toast = Toast.loading({
                        duration: 0,
                        message: '添加中',
                        forbidClick: true,
                        loadingType: 'spinner',
                    });
					if(this.single_store=='1'){
						this.store_ids[0]=this.select_stores.store_id;
					}
                    this.$http.post('/wechat/api.card/addCard', {
                        name: this.name,
						store_ids:this.store_ids,
						picture:this.picture,
						background:this.background,
						single_store:this.single_store,
						full_money:this.full_money,
						give_integral:this.give_integral,
						discount:this.data_list,
                        // openid: window.localStorage.getItem("openid")
                    }).then(response => {
                        toast.clear();
                        if (response && response.data.code== 200) {

                            this.$router.push("/member_card");

                            // VueCookie.set('salesmanInfo', response.data.data, 360000);
                            // window.location.href = that.redirect;

                        }else{
                            Notify({type: 'danger', message: response.data.msg});
                        }
                    })

                }).catch(() => {
                    this.$toast.fail('必填项未填写')
                })
                // window.sessionStorage.setItem("tag",this.ta)
                //  var that = this;




            },
        },
    }
</script>

<style >
    .van-icon-goods-collect-o::before{
        position: relative;
        top: 0.1rem;
    }
    .van-icon-contact::before{
        position: relative;
        top: 0.1rem;
    }

    .van-field >>>.van-field__label{
        width: 30px;
    }
</style>
